import React from "react"
import NewCompactProgressBar from "./NewCompactProgressBar"
import { CompressedMSRLoader } from "../PDRCredits"

export const CompactPDRWrapper = ({ currentPerson }) => (
  <NewCompactProgressBar currentPerson={currentPerson} />
)

const NewCompactPDR = ({ loading, data }) =>
  loading ? (
    <CompressedMSRLoader />
  ) : (
    <CompactPDRWrapper currentPerson={data.currentPerson} />
  )

export default NewCompactPDR
